app.headerController = app.headerController || {};

app.headerController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.fixedHeader();
    },
    
    fixedHeader : function () {
        var $body = $('body'),
            scrollOffset = function() { return $(document).scrollTop(); },
            lastScrollOffset = 0,
            $siteHeader = $('.siteHeader'),
            onTop = false,
            wasScrollingUp = false;;
    
        // Toggle scrollingUp/scrollingDown class on body when scrolling up/down
        $(window).on('load', function() {
            if (! $body.hasClass('activeNav')) {
                    scrollDetection();
            }
        });
        $(document).on('scroll', function() {
            if (! $body.hasClass('activeNav')) {
                scrollDetection();
            }
        });
        
        function scrollDetection() {

            // Scroll on top
            if (scrollOffset() <= $siteHeader.innerHeight() ) {
                if (!onTop) {
                    onTop = true;
                    $body.addClass('onTop');
                    $body.removeClass('scrollingDown scrollingUp');
                }
            }
            // Scrolling
            else {
                if (onTop) {
                    onTop = false;
                }
                else {
                    $body.removeClass('onTop');
                }
                // Scrolling up
                if (scrollOffset() < lastScrollOffset) {
                    if (!$body.hasClass('scrollingUp')) {
                        $body.removeClass('scrollingDown').addClass('scrollingUp');
                    }
                }
                // Scrolling down
                else if (scrollOffset() > lastScrollOffset) {
                    if (!$body.hasClass('scrollingDown')) {
                        $body.removeClass('scrollingUp').addClass('scrollingDown');
                    }
                }
            }
            lastScrollOffset = scrollOffset();

        }
    },

};
